import {
    GALLERY_DETAIL_RESET,
    GALLERY_DETAIL_INFO_FETCH,
    GALLERY_DETAIL_ADS_FETCH
} from './constants';
import {
    getGalleryDetails,
    getGalleryAds
} from '../services/gallery'

export const startFetchGalleryDetails = (advertiseId) => {
    return (dispatch, getState) => {
        return getGalleryDetails(advertiseId)
        .then((response) => {
            dispatch(fetchGalleryDetails(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchGalleryDetails = (payload) => ({
    type: GALLERY_DETAIL_INFO_FETCH,
    payload
});

export const startFetchGalleryAds = (advertiseId) => {
    return (dispatch, getState) => {
        return getGalleryAds({
                parameter: getState().galleryDetailFilters,
                id: advertiseId
            })
            .then((response) => {
                dispatch(fetchGalleryAds(response.data))
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                }
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                }
            })
    }
};

const fetchGalleryAds = (payload) => ({
    type: GALLERY_DETAIL_ADS_FETCH,
    payload
});

export const resetGalleryDetails = (payload) => ({
    type: GALLERY_DETAIL_RESET,
    payload
});